import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { useTranslation } from 'react-i18next';

const ListButton = ({ isInList, onClick, size = 'small' }) => {
  const { t } = useTranslation();

  const tooltipContent = isInList
    ? t('dataCatalog.actions.inLists')
    : t('dataCatalog.actions.addToLists');

  return (
    <Tooltip title={tooltipContent}>
      <IconButton
        aria-label={tooltipContent}
        onClick={(e) => {
          e.stopPropagation();
          onClick(e);
        }}
        size={size}
        color={isInList ? 'primary' : 'default'}
      >
        {isInList ? <PlaylistAddCheckIcon /> : <PlaylistAddIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ListButton;
